<template>
    <div class="notice_list">
        <div class="notice_item" v-for="(item,index) in list" :key="index" :id="item.id" @click="listDetails($event)">
            <div class="notice_plate" :style="{'background-image':'url('+item.imageUrl+')'}">
                <!-- <div class="chara" v-for="(val,k) in item.dec" :key="k" :class="[k%2==0?'blue':'orange']">{{val}}</div> -->
            </div>
            <div class="notice_title">{{item.title}}</div>
            <div class="notice_time">{{item.createtime}}</div>
        </div>
    </div>
</template>

<script>
import autho from '../autho/autho.js'
var that;
export default {
    data(){
        return {
            list:[],
            hasNextPage:false,
            page:1
        }
    },
    beforeCreate(){
        that = this;
        document.querySelector('body').style.background = '#f6f6f6'
    },
    methods:{
        listDetails(e){
            that.$router.push({path:'/details',query: { id: e.currentTarget.getAttribute('id')}})
        },
        // 请求后台数据
        async requestFun(page){
            const res = await autho.request('token','post','/gzhWxApiController/getNoticeList',{page:page})
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                that.hasNextPage = _data.hasNextPage;
                if(_data.list.length > 0){
                    that.list = that.list.concat(_data.list)
                }
            })
        },
        // 页面加载更多
        handleScroll(){
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            if(scrollTop + windowHeight > scrollHeight - 240){
                if(that.hasNextPage == true){
                    that.hasNextPage = false;
                    that.page++;
                    that.requestFun(that.page)
                }
            }
        }
    },
    mounted(){
        
    },
    destroyed(){
        
    },
    activated(){
        that.page = 1;
        that.list = [];
        that.requestFun(that.page)
        window.addEventListener('scroll', that.handleScroll)
    },
    deactivated(){
        window.removeEventListener('scroll', that.handleScroll)
    }
}
</script>


<style scoped>
.notice_item {
    padding: 0.1rem;
    background: #fff;
    border-radius: 0.05rem;
    margin: 0.2rem auto 0;
    width: 3.25rem;
}
.notice_plate {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    width: 3.25rem;
    height: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.chara {
    width: 0.53rem;
    height: 0.53rem;
    background: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 0.53rem;
    font-size: 0.29rem;
    margin-right: 0.05rem;
}
.blue {
    color: #3078da;
}
.orange {
    color: #da8030;
}
.notice_title {
    font-size: 0.19rem;
    color: #000;
    margin-top:0.1rem;
}
.notice_time {
    font-size: 0.12rem;
    color: #828282;
    margin-top:0.1rem;
}
</style>